var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"agenda-dia"},[_c('v-card',{staticClass:"py-4 px-2 auth-content",attrs:{"tile":""}},[_c('PageTitle',{attrs:{"icon":"mdi-pencil-box-outline","main":"Agenda de eventos","sub":"Eventos","home":"/legislativo"}}),_c('div',[_c('formulario')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }